import { PageHeader } from '@celltrak/ui-components';

const ReasonHeader = () => (
  <header>
    <PageHeader title="Reason Codes" />
  </header>
);

export default ReasonHeader;
